import { AlertCircle, LogOut, RefreshCcw } from "lucide-react";

import { resetAppStorageForLogout } from "../../utils/scopedStorage";

export default function OnPremUnavailableState({ message }) {
  return (
    <div className="onprem-state is-error">
      <AlertCircle size={22} />
      <div>
        <strong>On-prem administration unavailable</strong>
        <p>{message}</p>
      </div>
      <div className="onprem-state-actions">
        <button type="button" className="onprem-button is-secondary" onClick={() => window.location.reload()}>
          <RefreshCcw size={15} /> Refresh profile
        </button>
        <button
          type="button"
          className="onprem-button is-secondary"
          onClick={() => {
            resetAppStorageForLogout();
            window.location.href = "/login";
          }}
        >
          <LogOut size={15} /> Log out
        </button>
      </div>
    </div>
  );
}
